import getLayout from '../../Layout/LayoutConfiguration';
import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';
import { getCustomerDBCredentialsByUserId } from 'services/customer-db-credentials.service';
import { setAuth } from 'services/identity.service';

// 🎉 Toast imports
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'react-hot-toast';

const updateSessionData = async (session, sessionUpdate) => {
  const responseCredentials = await getCustomerDBCredentialsByUserId();
  if (responseCredentials?.entity) {
    if (session) {
      if (session.user && session.user.isNewUser === false) {
        session.user.name = `${session.user.firstName} ${session.user.lastName}`;
        session.user.elasticIndexName = responseCredentials?.entity.indexName;
        sessionUpdate(session);
      }
    }
  }
};

const App = ({ Component, pageProps, router }) => {
  if (!['/login', '/welcome'].includes(router.pathname)) {
    const { data: session, update: sessionUpdate } = useSession();

    // Sync the AUTH cookie when the next-auth session object changes.
    // Using a ref so this only fires when useSession() provides a new object —
    // not on every arbitrary re-render. Unconditional setAuth(session) on every
    // render overwrites fresh tokens written by onboarding/refresh flows before
    // triggerCoreOnboarding() can read them from the cookie.
    const prevSessionRef = useRef(null);
    if (session && session !== prevSessionRef.current) {
      prevSessionRef.current = session;
      setAuth(session);
    }
    useEffect(() => {
      if (
        session &&
        session.user &&
        session.user.isNewUser === false &&
        !session.user.elasticIndexName
      ) {
        updateSessionData(session, sessionUpdate);
      }
    }, []);

    useEffect(() => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const timeUntilMidnight = midnight - now;

      const timer = setTimeout(() => {
        window.location.reload();
      }, timeUntilMidnight);

      return () => clearTimeout(timer);
    }, []);
  }

  const LayoutComponent = getLayout(router.pathname);

  return (
    <>
      <LayoutComponent>
        <Component {...pageProps} />
      </LayoutComponent>
      
      {/* 🎉 Toast Container - Available throughout your entire app */}
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        className="custom-toast-container"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        progressClassName="custom-toast-progress"
      />
      {/* Hooks that import react-hot-toast show their messages here; without it they are dropped. */}
      <Toaster position="top-right" />
    </>
  );
};

export default App;